export const catergoryOptions = [
  { text: 'Drinks', value: 'drinks' },
  { text: 'Culture', value: 'culture' },
  { text: 'Film', value: 'film' },
  { text: 'Food', value: 'food' },
  { text: 'Music', value: 'music' },
  { text: 'Travel', value: 'travel' },
];
